module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/hairstyle_03-01ccc5a4bb05f95b0a58f55df8274bf9.webp";